import { render, staticRenderFns } from "./HeadBtnList.vue?vue&type=template&id=a5fa7930&scoped=true&"
import script from "./HeadBtnList.vue?vue&type=script&lang=js&"
export * from "./HeadBtnList.vue?vue&type=script&lang=js&"
import style0 from "./HeadBtnList.vue?vue&type=style&index=0&id=a5fa7930&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fa7930",
  null
  
)

export default component.exports